var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "001-mastercard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.213,
    height: 73.37,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17926"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17925"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6734",
    d: "M30.17 31.817a10.683 10.683 0 0 0-3.746.682l-.449 2.666a9.76 9.76 0 0 1 3.372-.545c1.153 0 1.994.128 1.994 1.064a2 2 0 0 1-.1.78s-.908-.074-1.329-.074c-2.676 0-5.486 1.139-5.486 4.584 0 2.714 1.842 3.333 2.987 3.333a4.02 4.02 0 0 0 3.173-1.419l-.1 1.183h2.724l1.215-8.519c-.008-3.619-3.161-3.735-4.255-3.735Zm-1.531 9.898a1.127 1.127 0 0 1-1.211-1.169c0-.846.459-1.864 2.726-1.864a1.941 1.941 0 0 1 .674.072c.063.522-.321 2.961-2.189 2.961Z",
    fill: "#4e87ae"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17928"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17927"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6735",
    d: "M40.008 34.673c.435 0 2.113.138 2.113.138l.391-2.73a14.43 14.43 0 0 0-2.854-.243c-2.289 0-4.61.914-4.61 4.039 0 3.544 3.873 3.183 3.873 4.678 0 .994-1.082 1.076-1.916 1.076a9.9 9.9 0 0 1-2.748-.473l-.413 2.708a9.99 9.99 0 0 0 3.472.377c.7 0 4.678.18 4.678-3.931 0-3.845-3.686-3.085-3.686-4.63-.002-.766.597-1.009 1.7-1.009Z",
    fill: "#4e87ae"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17930"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17929"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6736",
    d: "M46.516 35.023h1.638l.395-2.91h-1.544l.315-1.8h-3.093c-.068.066-1.826 10.175-1.826 11.4a2.3 2.3 0 0 0 2.465 2.622 7.973 7.973 0 0 0 2.319-.407l.387-2.63c-.212 0-.523.092-.8.092-1.076 0-1.195-.575-1.127-1Z",
    fill: "#4e87ae"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17932"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17931"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6737",
    d: "M59.479 18.136h-5.52c-.742 1-1.439 2.069-2.071 3.111h9.848a29.419 29.419 0 0 0-2.257-3.111Z",
    fill: "#4e87ae"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17934"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17933"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6738",
    d: "M102.551 53.131a1.6 1.6 0 0 0-.15-.2.216.216 0 0 0-.086-.052.315.315 0 0 0 .21-.092.277.277 0 0 0 .078-.192.269.269 0 0 0-.046-.148.243.243 0 0 0-.128-.1.762.762 0 0 0-.255-.03h-.348v1.012h.164V52.9h.094a.192.192 0 0 1 .128.036.911.911 0 0 1 .172.235l.088.16h.2Zm-.365-.365h-.2v-.3h.188a.481.481 0 0 1 .16.018.158.158 0 0 1 .07.052.138.138 0 0 1 .024.078.142.142 0 0 1-.05.114.336.336 0 0 1-.192.038Z",
    fill: "#4e87ae"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17936"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17935"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6739",
    d: "M63.41 24.3H50.166c-.846 1.6-1.407 2.812-1.565 3.113h16.064A29.342 29.342 0 0 0 63.41 24.3Z",
    fill: "#4e87ae"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17938"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17937"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6740",
    d: "m20.63 29.354-3.049 9.04-.158-9.04h-4.512l-2.474 14.731h2.985l1.882-11.1.277 11.1h2.131l3.975-11.1-1.762 11.1h3.167l2.438-14.731Z",
    fill: "#4e87ae"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17940"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17939"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6741",
    d: "M80.317 31.817a10.674 10.674 0 0 0-3.748.682l-.451 2.666a9.774 9.774 0 0 1 3.372-.545c1.153 0 2 .128 2 1.064a1.936 1.936 0 0 1-.106.78s-.906-.074-1.331-.074c-2.674 0-5.482 1.139-5.482 4.584 0 2.714 1.844 3.333 2.987 3.333a4.03 4.03 0 0 0 3.173-1.419l-.1 1.183h2.715l1.215-8.519c.005-3.619-3.15-3.735-4.244-3.735Zm-1.523 9.9a1.125 1.125 0 0 1-1.211-1.169c0-.846.459-1.864 2.726-1.864a1.965 1.965 0 0 1 .673.072c.058.52-.328 2.959-2.189 2.959Z",
    fill: "#4e87ae"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17942"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17941"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6742",
    d: "M102.649 42.727a.845.845 0 0 0-.353-.349.934.934 0 0 0-.461-.122 1.01 1.01 0 0 0-.461.122.852.852 0 0 0-.351.349.947.947 0 0 0-.126.469.927.927 0 0 0 .126.465.9.9 0 0 0 .347.351.957.957 0 0 0 .465.124.942.942 0 0 0 .467-.124.95.95 0 0 0 .471-.816.923.923 0 0 0-.124-.469Zm-.13.856a.755.755 0 0 1-.291.293.774.774 0 0 1-.776 0 .747.747 0 0 1-.293-.293.769.769 0 0 1 0-.78.729.729 0 0 1 .293-.291.783.783 0 0 1 .385-.1.773.773 0 0 1 .381.1.717.717 0 0 1 .293.291.8.8 0 0 1 .108.391.781.781 0 0 1-.1.389Z",
    fill: "#4e87ae"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17944"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17943"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6743",
    d: "M102.154 43.515a1.255 1.255 0 0 0-.148-.2.231.231 0 0 0-.086-.052.31.31 0 0 0 .208-.092.279.279 0 0 0 .08-.192.261.261 0 0 0-.048-.148.284.284 0 0 0-.124-.1.776.776 0 0 0-.257-.03h-.353v1.01h.164v-.429h.094a.218.218 0 0 1 .132.034 1.022 1.022 0 0 1 .172.239l.086.158h.2Zm-.361-.371h-.2v-.307h.184a.6.6 0 0 1 .164.016.158.158 0 0 1 .066.054.13.13 0 0 1 .026.082.148.148 0 0 1-.048.11.29.29 0 0 1-.192.045Z",
    fill: "#4e87ae"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17946"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17945"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6744",
    d: "M90.833 31.963c-1.385 0-2.413 1.89-2.413 1.89l.277-1.738h-2.888l-1.93 11.991h3.175c.9-5.123 1.068-9.279 3.215-8.519a11.894 11.894 0 0 1 1.155-3.584 3.532 3.532 0 0 0-.591-.04Z",
    fill: "#4e87ae"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17948"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17947"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6745",
    d: "m98.807 29.37-.667 4.139a4.082 4.082 0 0 0-2.987-1.61c-2.836 0-5.2 3.42-5.2 7.344 0 2.536 1.261 5.019 3.835 5.019a3.865 3.865 0 0 0 2.88-1.293l-.134 1.1h3.009l2.365-14.711Zm-3.923 11.887c-1.114 0-1.636-.934-1.636-2.4 0-2.4 1.076-3.981 2.437-3.981 1.11 0 1.682.766 1.682 2.566.001 1.634-.807 3.815-2.483 3.815Z",
    fill: "#4e87ae"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17950"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17949"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6746",
    d: "M110.3 0H2.915A2.913 2.913 0 0 0 0 2.915v67.54a2.913 2.913 0 0 0 2.915 2.915H110.3a2.913 2.913 0 0 0 2.915-2.915V2.915A2.913 2.913 0 0 0 110.3 0Zm-7.25 53.277a.872.872 0 0 1-.347.351.94.94 0 0 1-.934 0 .9.9 0 0 1-.349-.351.94.94 0 0 1-.124-.465.953.953 0 0 1 .126-.469.864.864 0 0 1 .351-.349.99.99 0 0 1 .463-.12.975.975 0 0 1 .459.12.852.852 0 0 1 .351.349.956.956 0 0 1 .124.469.91.91 0 0 1-.122.465Zm2.1-16.591A29.051 29.051 0 0 1 56.6 58.234a29.052 29.052 0 1 1-19.664-50.6h.186A28.94 28.94 0 0 1 56.6 15.136a29.054 29.054 0 0 1 48.55 21.536s-.001.006-.001.014Z",
    fill: "#4e87ae"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17952"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17951"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6747",
    d: "M53.626 55.057a28.914 28.914 0 0 0 2.971 3.175c.024-.022.05-.042.074-.062h.002a29.04 29.04 0 0 0 2.951-3.111Z",
    fill: "#4e87ae"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17954"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17953"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6748",
    d: "M57.583 39.109a22.207 22.207 0 0 0 .407-2.82c0-2.039-1.014-4.524-4.41-4.524-3.111 0-5.414 3.353-5.414 7.142 0 4.372 2.884 5.41 5.344 5.41a7.846 7.846 0 0 0 3.267-.509l.545-2.983a9.618 9.618 0 0 1-3.285.762c-3.321 0-2.74-2.478-2.74-2.478Zm-3.993-4.568c1.746 0 1.423 1.962 1.423 2.119H51.58c0-.203.324-2.119 2.01-2.119Z",
    fill: "#4e87ae"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17956"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17955"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6749",
    d: "M72.091 32.176a5.508 5.508 0 0 1 2.838.884l.505-3.277a11.093 11.093 0 0 0-3.484-.758c-3.57 0-7.044 3.1-7.044 8.918 0 3.859 1.874 6.406 5.566 6.406a14.335 14.335 0 0 0 2.706-.423l.553-3.376a7.43 7.43 0 0 1-2.558.76c-2.2 0-3.077-1.678-3.077-3.474.002-3.653 1.89-5.66 3.995-5.66Z",
    fill: "#4e87ae"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17958"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17957"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6750",
    d: "M49.747 48.953a28.73 28.73 0 0 0 1.716 3.111h10.309a29.1 29.1 0 0 0 1.692-3.111Z",
    fill: "#4e87ae"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17960"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17959"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6751",
    d: "M64.85 31.967c-1.385 0-2.411 1.89-2.411 1.89l.279-1.738h-2.88L57.907 44.11h3.175c.9-5.121 1.068-9.279 3.215-8.519a11.9 11.9 0 0 1 1.151-3.588 3.134 3.134 0 0 0-.598-.036Z",
    fill: "#4e87ae"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.af9d90a892c21d39d138d4ec8d6128e9.svg";
export { ForwardRef as ReactComponent };